import { CurrencyApi, CurrencyDataType } from '@/api/CurrencyApi';
import { CURRENCIES, CURRENCIES_CODES, CURRENCIES_SYMBOLS } from './Constants';
import { RecibeDataType } from '@/api/RecibeApi';

export const generateCurrencyOptionLabel = (currency: CurrencyDataType): string => {
    if (currency.currency_id) {
        const currencyID = parseInt(`${currency.currency_id}`);
        return CURRENCIES[currencyID]
    }
    return ""
}

export const getCurrencyCode = (currencyId: string | undefined | null): string => {
    const key = Number(currencyId);
    return CURRENCIES_CODES[key];
}

export const getDefaultCurrency = async (): Promise<RecibeDataType> => {
    const { items } = await CurrencyApi.fetchAll({ is_default: { eq: true } });
    if (items.length > 0) {
        return items[0] as RecibeDataType;
    }
    return {}
}

export const formatMoneyValue = (value: Number | undefined, currency_id: number | undefined): string => {
    if (value != null && value != undefined && currency_id != null && currency_id != undefined) {
        const moneyValue = Number(value || 0);
        // Usamos Intl.NumberFormat para separar miles con espacio
        const formattedValue = new Intl.NumberFormat("es-CR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,
        })
            .format(moneyValue)
            .replace(/\u00A0/g, " ");
        const symbol = CURRENCIES_SYMBOLS[currency_id];
        return `${symbol} ${formattedValue}`;
    }
    return ""
}